import React from 'react';

const SPARKLE_PATH =
  'M8.7392 3.95325C8.80091 3.67456 9.19822 3.67456 9.25993 3.95325L9.63755 5.65874C9.93641 7.00854 10.9906 8.06272 12.3404 8.36159L14.0459 8.7392C14.3246 8.80091 14.3246 9.19822 14.0459 9.25993L12.3404 9.63755C10.9906 9.93641 9.93641 10.9906 9.63755 12.3404L9.25993 14.0459C9.19822 14.3246 8.80091 14.3246 8.7392 14.0459L8.36159 12.3404C8.06272 10.9906 7.00854 9.93641 5.65874 9.63755L3.95325 9.25993C3.67456 9.19822 3.67456 8.80091 3.95325 8.7392L5.65874 8.36159C7.00854 8.06272 8.06272 7.00854 8.36159 5.65874L8.7392 3.95325Z';

export const SparkleIcon: React.FC<{ svgClassName?: string }> = ({
  svgClassName,
}) => (
  <svg
    width="18"
    height="18"
    viewBox="0 0 18 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    style={{ display: 'block', flexShrink: 0 }}
    className={svgClassName}
  >
    <path d={SPARKLE_PATH} fill="var(--eclipse-text-color)" />
  </svg>
);

export const CloseIcon: React.FC = () => (
  <svg
    width="18"
    height="18"
    viewBox="0 0 18 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    style={{ display: 'block' }}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M8.43928 9.49994L5.99994 7.0606C5.70705 6.76771 5.70705 6.29284 5.99994 5.99994C6.29284 5.70705 6.76771 5.70705 7.0606 5.99994L9.49994 8.43928L11.9393 5.99994C12.2322 5.70705 12.7071 5.70705 12.9999 5.99994C13.2928 6.29284 13.2928 6.76771 12.9999 7.0606L10.5606 9.49994L12.9999 11.9393C13.2928 12.2322 13.2928 12.7071 12.9999 12.9999C12.7071 13.2928 12.2322 13.2928 11.9393 12.9999L9.49994 10.5606L7.0606 12.9999C6.76771 13.2928 6.29284 13.2928 5.99994 12.9999C5.70705 12.7071 5.70705 12.2322 5.99994 11.9393L8.43928 9.49994Z"
      fill="#000624"
    />
  </svg>
);

export const AccordionIcon: React.FC<{ svgClassName?: string }> = ({
  svgClassName,
}) => (
  <svg
    width="18"
    height="18"
    viewBox="0 0 18 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    style={{ display: 'block' }}
    className={svgClassName}
  >
    <path
      d="M5.28091 11.7191C5.10104 11.539 5 11.2949 5 11.0403C5 10.7858 5.10104 10.5416 5.28091 10.3615L8.90278 6.73968C9.08288 6.5598 9.32701 6.45877 9.58156 6.45877C9.8361 6.45877 10.0802 6.5598 10.2603 6.73968L13.8822 10.3615C14.0519 10.5436 14.1442 10.7845 14.1399 11.0333C14.1355 11.2822 14.0347 11.5196 13.8587 11.6956C13.6827 11.8716 13.4453 11.9724 13.1964 11.9768C12.9476 11.9811 12.7067 11.8888 12.5246 11.7191L9.58156 8.7773L6.63847 11.7191C6.45837 11.899 6.21424 12 5.95969 12C5.70515 12 5.46101 11.899 5.28091 11.7191Z"
      fill="#000624"
    />
  </svg>
);
